import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import dayjs from "dayjs";

import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import isEmpty from "lodash-es/isEmpty";

import {
  StripedTableRow,
  StripedTableCell,
  StripedTableHeadCell,
} from "../StripedTable";

function AttendeeDetailsDialog({ onClose, open, attendee }) {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const getComments = (student) => {
    if (student == null) {
      return "-- NONE --";
    }
    if (isEmpty(student.comment) && isEmpty(student.teacherComment)) {
      return "-- NONE --";
    }
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          maxWidth: 450,
          maxHeight: 400,
        },
      }}
      onClose={handleClose}
      open={open}
      fullScreen={true}
    >
      <DialogTitle id="select-student-list-dialog-title">
        Attendee Details
      </DialogTitle>

      <DialogContent>
        <TableContainer component={Paper} sx={{ mt: 0 }}>
          <Table size="small">
            <TableBody>
              <StripedTableRow>
                <StripedTableHeadCell>Student:</StripedTableHeadCell>
                <StripedTableCell>
                  {attendee.last_name}, {attendee.first_name}
                  {isEmpty(attendee.mi) === false && <> {attendee.mi}.</>}
                </StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Date Created:</StripedTableHeadCell>
                <StripedTableCell>{dayjs(attendee.dateCreated).format("MM/DD hh:mm")}</StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>
                  Is Assigned by Teacher:
                </StripedTableHeadCell>
                <StripedTableCell>
                  {attendee.assignedByTeacherLastName == null && "NO"}
                  {attendee.assignedByTeacherLastName != null && "YES"}
                </StripedTableCell>
              </StripedTableRow>
              {attendee.assignedByTeacherLastName != null && (
                <StripedTableRow>
                  <StripedTableHeadCell>Assigned By:</StripedTableHeadCell>
                  <StripedTableCell>
                    {attendee.assignedByTeacherLastName},{" "}
                    {attendee.assignedByTeacherFirstName}
                  </StripedTableCell>
                </StripedTableRow>
              )}
              {attendee.lockTeacherLastName != null && (
                <StripedTableRow>
                  <StripedTableHeadCell>Locked By:</StripedTableHeadCell>
                  <StripedTableCell>
                    {attendee.lockTeacherLastName},{" "}
                    {attendee.lockTeacherFirstName}
                  </StripedTableCell>
                </StripedTableRow>
              )}
              <StripedTableRow>
                <StripedTableHeadCell>Comment:</StripedTableHeadCell>
                <StripedTableCell>
                  {getComments(attendee.comment)}
                </StripedTableCell>
              </StripedTableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AttendeeDetailsDialog;
